import { render, staticRenderFns } from "./ReceptionDetail.vue?vue&type=template&id=c5d323f8"
import script from "./ReceptionDetail.vue?vue&type=script&lang=js"
export * from "./ReceptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports